import { gql } from "@apollo/client";

export const LOGIN = gql`
mutation Login($input: LoginInput) {
  login(input: $input) {
    success
    message
    error
    token
    user {
      id
      username
      email
      password_hash
      user_type
      type_code
      status_code
      first_name
      last_name
      created_date
      modified_date
    }
  }
}
`

export const UPDATE_PASSWORD = gql`
mutation updatePassword($email: String!, $oldPassword: String!, $newPassword: String!){
    updatePassword(input:{
        email: $email
        oldPassword: $oldPassword
        newPassword: $newPassword
    }){
        error
        message
        success
    }
}
`

export const UPDATE_USER = gql`
    mutation terminateUser($input: TerminaionInput!, $userEmail: String!) {
        terminateUser(input: $input, userEmail: $userEmail) {
    user {
      id
      username
      email
      password_hash
      user_type
      type_code
      status_code
      created_date
      modified_date
    }
    success
    message
    error
  }
}
`